import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📚 Academia Cemento Elite (12 Tomos)',
  price: '$19.990'
}, {
  label: '🎁 Mapa de Proveedores Argentina',
  price: 'GRATIS'
}, {
  label: '🎁 Smart-Cost Cemento (Calculadora)',
  price: 'GRATIS'
}, {
  label: '🎁 Fotografía Boutique con Celular',
  price: 'GRATIS'
}, {
  label: '🎁 Pack 20 Plantillas de Instagram',
  price: 'GRATIS'
}, {
  label: '🎁 Masterclass Efecto Mármol Veteado',
  price: 'GRATIS'
}, {
  label: '🛡️ Garantía 7 días',
  price: 'INCLUIDA'
}];
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago · Tarjeta'
}];
export function ValueStack() {
  return <section id="value" aria-label="Resumen de la oferta" className="border-y border-white/5 bg-ink-2" data-id="element-185" data-mp="35ov4mehoht4l">
      <div className="mx-auto max-w-2xl px-5 pb-[21px] text-center" style={{
      paddingTop: '9px'
    }} data-id="element-186" data-mp="1tgejy12gdqu9">
        <h2 className="font-display text-2xl font-black text-white sm:text-4xl" data-id="element-187" data-mp="1ohbdqdaqlekp">
          🚀 Lanzá tu taller de cemento hoy
        </h2>
        <p className="text-sm text-white/60" style={{
        paddingTop: '22px',
        marginTop: '-20px',
        marginBottom: '-20px'
      }} data-id="element-188" data-mp="23798jc3692iv">
          Un pago único. Acceso de por vida. Sistema listo para aplicar en minutos.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-white/10 bg-ink text-left" data-id="element-189" data-mp="2850yw1o64gky">
          <div className="flex items-center justify-between border-b border-white/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-white/50" style={{
          paddingTop: '0px',
          marginTop: '-15px',
          marginBottom: '-15px'
        }} data-id="element-190" data-mp="2m4agn5s0vir1">
            <span data-id="element-191" data-mp="rru8u0jkvwk2">Qué incluye</span>
            <span data-id="element-192" data-mp="mrpuoh657dx0">Precio</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-white/5 px-5 text-sm" style={{
          paddingTop: '1px',
          paddingBottom: '13px'
        }} data-id="element-193" data-mp="2mtfk0gc1mdy8">
              <span className="text-white/80" style={{
            paddingTop: '4px'
          }} data-id="element-194" data-mp="2vssv1dftfal2">
                {r.label}
              </span>
              <span className={r.price.startsWith('$') ? 'shrink-0 font-bold text-white' : 'shrink-0 font-bold text-gold'} data-id="element-195" data-mp="30ui6gu6y9q9o">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-wrap items-center justify-between gap-2 bg-white/5 px-5" style={{
          paddingTop: '4px',
          paddingBottom: '0px'
        }} data-id="element-196" data-mp="3fimsa71auhwo">
            <span className="text-sm font-bold text-white" style={{
            textAlign: 'center'
          }} data-id="element-197" data-mp="3ok2u3qe1tbpa">
              Valor total real: <span className="text-white/40 line-through" data-id="element-198" data-mp="3thvzih7j21oi">$70.990</span>
            </span>
            <span className="font-display text-2xl font-black text-gold-shine" style={{
            textAlign: 'center'
          }} data-id="element-199" data-mp="7hq7lcl00nmz">
              $19.990 ARS
            </span>
          </div>
        </div>

        <div style={{
        paddingTop: '14px',
        marginTop: '-5px',
        marginBottom: '-5px'
      }} data-id="element-200" data-mp="3tp6mbwsu1hpg">
          <CTAButton data-id="element-201" data-mp="3pnutzjikqidk">Sí, quiero emprender con cemento</CTAButton>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50" data-id="element-202" data-mp="q64z00z8a3ob">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-203" data-mp="gg1zdhxlprh0">
              <Icon className="h-4 w-4 text-gold" data-id="element-204" data-mp="cfhxk1231zoj" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}